import React from 'react';
import { createFrontendPlugin, PageBlueprint } from '@backstage/frontend-plugin-api';

const homePage = PageBlueprint.make({
  params: {
    path: '/',
    loader: () =>
      import('./HomePage').then(m => React.createElement(m.HomePage)),
  },
});

export const homePlugin = createFrontendPlugin({
  pluginId: 'home',
  extensions: [homePage],
});
